import { SalesInvoiceFilters } from '../../../../app/models/SalesInvoice';
import { SalesInvoiceHistoryDataForm, SalesInvoiceHistoryFilters } from '../../../../app/models/SalesInvoiceHistory';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { momentParseDate } from '../../../../helpers';
import { formatMoney } from '../../../../utils/utils';
import SalesInvoiceHistoryFilter from './SalesInvoiceHistoryFilter';

interface Props {
    salesInvoiceHistories: SalesInvoiceHistoryDataForm[];  
    salesInvoiceId: number;
    totalRows: number;
    loading?: boolean;
    filter: SalesInvoiceHistoryFilters;
    setFilter: (filter: SalesInvoiceHistoryFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
}

const SalesInvoiceHistoryDataTable = ({
    salesInvoiceHistories,
    salesInvoiceId,
    totalRows,
    loading = false,
    filter,
    setFilter,
    callbackSuccess
}: Props) => {
    const columns = [
        {
            name: 'ID',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: SalesInvoiceHistoryDataForm) => (
                <span className="">{row.id}</span>
            )
        },

        {
            name: 'Descripcion',
            selector: (row: any) => row.description,
            sortable: true,
            sortField: 'description',
            cell: (row: SalesInvoiceHistoryDataForm) => (
                <span className="">{row.description}</span>
            )
        },

        {
            name: 'Razón del Cambio',
            selector: (row: any) => row.reason,
            sortable: true,
            sortField: 'reason',
            cell: (row: SalesInvoiceHistoryDataForm) => (
                <span className="">{row.reason}</span>
            )
        },
        {
            name: 'Estado',
            selector: (row: any) => row.status,
            sortable: true,
            sortField: 'status',
            cell: (row: SalesInvoiceHistoryDataForm) => (
                <span className="">{row.status}</span>
            )
        },
        {
            name: 'Creado por',
            selector: (row: any) => row.created_user?.username,
            sortable: true,
            sortField: 'created_user',
            cell: (row: SalesInvoiceHistoryDataForm) => (
                <span className="">
                <div
                    dangerouslySetInnerHTML={{
                    __html: row.created_user ? String(row.created_user) : ''               

                }}
                />
            </span>
            )
        },
        {
            name: 'Fecha de Cambio',
            selector: (row: any) => row.created_at,
            sortable: true,
            sortField: 'created_at',
            cell: (row: SalesInvoiceHistoryDataForm) => (
                <span className="">{momentParseDate(row.created_at)}</span>
            )
        },
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <SalesInvoiceHistoryFilter filter={filter} setFilter={setFilter} />
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={salesInvoiceHistories}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default SalesInvoiceHistoryDataTable;

